// extracted by mini-css-extract-plugin
module.exports = {"currentDate":"CurrentDate_currentDate__tMCrP"};